import React from 'react';
import { Typography, Link } from '@mui/material';

interface DialogSizing {
    showContent: boolean;
}

const DataSources: React.FC<DialogSizing> = ({ showContent }) => {
    if (!showContent) return null;

    return (
        <>
            <Typography gutterBottom>3D scene data from:</Typography>

            <Typography>
                <Link href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener" underline="hover" color="primary">
                    © OpenStreetMap
                </Link>
            </Typography>

            <Typography>
                <Link href="https://www.swisstopo.admin.ch/" target="_blank" rel="noopener" underline="hover" color="primary">
                    © swisstopo
                </Link>
            </Typography>

            <Typography>
                <Link href="https://www.copernicus.eu/en" target="_blank" rel="noopener" underline="hover" color="primary">
                    © CCME 2023, provided under COPERNICUS by the European Union and ESA
                </Link>
            </Typography>
        </>
    );
};

export default DataSources;
